type JurisdictionDetails = {
  jurisdictionName: string;
  taxRate: number;
  taxAmount: number;
  taxAmountCents: number;
  taxCode: string;
  taxType: string;
  taxAddressType: string;
  exempt: boolean;
  standardType: boolean;
};

type LineItemTaxAuthority = {
  city: string;
  state: string;
  country: string;
};

type LineItemTaxClassification = {
  source: string;
  value: string;
};

class LineItemTaxInfo {
  taxRate: number;

  jurisdictionDetails: JurisdictionDetails[];

  taxAuthority: LineItemTaxAuthority;

  taxClassification: LineItemTaxClassification;

  constructor() {
    this.taxRate = 0;
    this.jurisdictionDetails = [];
    this.taxAuthority = {
      city: '',
      state: '',
      country: '',
    };
    this.taxClassification = {
      source: '',
      value: '',
    };
  }
}

export default LineItemTaxInfo;
